import { useEffect, useState } from "react";
import { useApp } from "../context/AppContext";
import { getContent } from "../lib/api";
import { Hash, RotateCcw } from "lucide-react";

export default function Dhikr() {
  const { t } = useApp();
  const [formulas, setFormulas] = useState([]);
  const [active, setActive] = useState(0);
  const [counts, setCounts] = useState(() => {
    try { return JSON.parse(localStorage.getItem("nour_dhikr") || "{}"); }
    catch { return {}; }
  });

  useEffect(() => { getContent("dhikr").then(setFormulas); }, []);
  useEffect(() => { localStorage.setItem("nour_dhikr", JSON.stringify(counts)); }, [counts]);

  if (!formulas.length) return <div className="p-6">…</div>;

  const f = formulas[active];
  const c = counts[f.id] || 0;
  const pct = Math.min(100, (c / f.target) * 100);

  const inc = () => {
    if (navigator.vibrate) navigator.vibrate(15);
    setCounts(x => ({ ...x, [f.id]: (x[f.id] || 0) + 1 }));
  };
  const reset = () => setCounts(x => ({ ...x, [f.id]: 0 }));

  return (
    <div className="space-y-6 fade-in" data-testid="dhikr-page">
      <header className="flex items-center gap-3">
        <div className="w-12 h-12 rounded-2xl bg-nour-primary text-white flex items-center justify-center"><Hash className="w-6 h-6" /></div>
        <div>
          <h1 className="font-heading text-2xl font-bold">{t.dhikr}</h1>
          <p className="text-sm text-nour-text2">{f.translit} · {t.target} {f.target}</p>
        </div>
      </header>

      <div className="flex gap-2 overflow-x-auto no-scrollbar" data-testid="dhikr-tabs">
        {formulas.map((x, i) => (
          <button
            key={x.id}
            onClick={() => setActive(i)}
            data-testid={`dhikr-tab-${i}`}
            className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition ${
              i === active ? "bg-nour-primary text-white" : "bg-white border border-[rgba(29,158,117,0.2)] text-nour-text2"
            }`}
          >
            {x.translit}
          </button>
        ))}
      </div>

      <div className="nour-card p-8 text-center" data-testid="dhikr-card">
        <div className="font-arabic-quran text-4xl text-nour-primary mb-2" dir="rtl">{f.ar}</div>
        <div className="text-sm text-nour-text2 italic mb-1">{f.translit}</div>
        <div className="text-base text-nour-text">{f.fr}</div>

        <div className="mt-8 flex justify-center">
          <button
            onClick={inc}
            data-testid="dhikr-counter-btn"
            aria-label="Dhikr counter"
            className="dhikr-btn w-52 h-52 rounded-full flex flex-col items-center justify-center select-none"
          >
            <div className="text-6xl font-extrabold text-nour-primary tabular-nums" data-testid="dhikr-count">{c}</div>
            <div className="text-xs text-nour-text2 mt-1">/ {f.target}</div>
          </button>
        </div>

        <div className="mt-6 max-w-md mx-auto">
          <div className="h-2 bg-emerald-100 rounded-full overflow-hidden">
            <div className="h-full bg-nour-primary transition-all" style={{ width: `${pct}%` }} />
          </div>
          <div className="mt-3 flex justify-center">
            <button className="btn-ghost" onClick={reset} data-testid="dhikr-reset"><RotateCcw className="w-4 h-4" /> {t.reset}</button>
          </div>
        </div>
      </div>
    </div>
  );
}
